import { useEffect, useRef } from "react";
import { trackDashboardFilterChanged } from "./productAnalytics";

/**
 * Fire dashboard_filter_changed when URL/query filter params change (skip initial hydrate).
 */
export function useEngagementQueryFilterTracking(
  queryFilters,
  dashboardId,
  scope = "dashboard",
) {
  const prevRef = useRef(null);
  const readyRef = useRef(false);

  useEffect(() => {
    const serialized = JSON.stringify(queryFilters || {});
    if (!readyRef.current) {
      readyRef.current = true;
      prevRef.current = serialized;
      return;
    }
    if (serialized === prevRef.current) return;
    prevRef.current = serialized;
    if (!Object.keys(queryFilters || {}).length) return;
    trackDashboardFilterChanged(dashboardId, queryFilters, { scope });
  }, [queryFilters, dashboardId, scope]);
}
